import './App.css'

import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import React, { Component } from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'

import DialogProvider from './components/DialogProvider'
import ChatIframePage from './containers/ChatIframePage'
import Analytics from './components/Analytics'
import ChatPage from './containers/ChatPage'
import AdminChatPage from './containers/AdminChatPage'
import TrackPage from './containers/TrackPage'
import ScrollToTop from './components/ScrollToTop'
import PresentationDetailPage from './containers/PresentationDetail/PresentationDetailPage'
import ProgramPage from './containers/ProgramPage'
import VenuePage from './containers/VenuePage'
import AppTemplate from './components/AppTemplate'
import AboutPage from './containers/AboutPage'
import SponsorsPage from './containers/SponsorsPage'
import ReportProblemPage from './containers/ReportProblemPage'
import { muiTheme } from './app/theme'
import {
  indexRoute,
  venueRoute,
  aboutRoute,
  sponsorsRoute,
  chatRoute,
  trackRoute,
  presentationDetailRoute,
  reportProblemRoute,
  programRoute,
} from './app/routes'

class App extends Component {
  render() {
    return (
      <Router>
        <MuiThemeProvider muiTheme={muiTheme}>
          <DialogProvider>
            <ScrollToTop excluded={['/', '/track/:id']}>
              <Analytics />
              <Switch>
                <Route path="/admin/chat/:key" component={AdminChatPage} />
                <Route
                  path="/iframe/chat/:appId/:roomId/:mode/:token?"
                  component={ChatIframePage}
                />
                <Route path={indexRoute}>
                  <AppTemplate>
                    <Route exact path={programRoute} component={ProgramPage} />
                    <Route path={venueRoute} component={VenuePage} />
                    <Route path={aboutRoute} component={AboutPage} />
                    <Route path={sponsorsRoute} component={SponsorsPage} />
                    <Route path={chatRoute} component={ChatPage} />
                    <Route path={trackRoute(':id')} component={TrackPage} />
                    <Route
                      path={presentationDetailRoute(':id')}
                      component={PresentationDetailPage}
                    />
                    <Route
                      path={reportProblemRoute}
                      component={ReportProblemPage}
                    />
                  </AppTemplate>
                </Route>
              </Switch>
            </ScrollToTop>
          </DialogProvider>
        </MuiThemeProvider>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js